import { qs } from "@fluorescent/dom";

import { section } from "@/glow";
import scrollContainer from "@/lib/scroll-container";
import { animateQuickLinks, shouldAnimate } from "@/lib/animation";

section("quick-links", {
  onLoad() {
    this.scrollContainer = qs("[data-scroll-container]", this.container);

    if (this.scrollContainer) {
      this.navScroller = scrollContainer.initScroller(this.scrollContainer);
    }
    if (shouldAnimate(this.container)) {
      this.animateQuickLinks = animateQuickLinks(this.container);
    }
  },

  onUnload() {
    this.animateQuickLinks?.destroy();
  },
});
